"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_BASE_SERVICE_WORKER_HEADER = exports.APP_BASE_RELEASE_SNAPSHOT_ROUTE = exports.APP_BASE_RELEASE_ROUTE = void 0;
/** The release of an App address its service worker checks and keeps. */
exports.APP_BASE_RELEASE_ROUTE = '/_app-release.json';
/** The confirmation of the release for the session of an App address. */
exports.APP_BASE_RELEASE_SNAPSHOT_ROUTE = '/_app-snapshot';
/**
 * Header of the service worker of an App address: with it the server answers
 * every file of the App with its stored bytes, the page document included,
 * so the worker checks them against their sha256. Code fetching with it gets
 * bytes, never a running page.
 */
exports.APP_BASE_SERVICE_WORKER_HEADER = 'x-streamlain-app-sw';
